'use client'
import { AnnualSubmissionModule } from '@repo/hmrc-itsa/AnnualSubmissionModule'

const ItsaMtdAnnual = () => {
  return <AnnualSubmissionModule />
}

export default ItsaMtdAnnual
